import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onMenuClick: () => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ isOpen, onClose, onMenuClick }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/admin/estabelecimentos', label: 'Estabelecimentos', icon: '🏪' },
    { path: '/admin/usuarios', label: 'Usuários', icon: '👤' },
    { path: '/admin/funcionarios', label: 'Funcionários', icon: '👷' },
  ];

  return (
    <>
      {/* Header mobile com hamburger */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-gray-900 text-white h-16 flex items-center justify-between px-4 z-20">
        <button
          onClick={onMenuClick}
          className="text-white p-2 -ml-2"
          aria-label="Abrir menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h1 className="text-lg font-bold text-yellow-400">Painel Admin</h1>
        <div className="w-10" /> {/* Spacer for centering */}
      </div>

      <div
        className={`h-full bg-gray-900 text-white w-64 fixed left-0 top-0 overflow-y-auto flex flex-col z-40 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {/* Botão de fechar para mobile */}
        <button
          onClick={onClose}
          className="lg:hidden absolute top-4 right-4 text-white text-3xl hover:text-gray-300 w-8 h-8 flex items-center justify-center z-50"
          aria-label="Fechar menu"
        >
          ×
        </button>

        <div className="p-4 border-b border-gray-700">
          <h1 className="text-xl font-bold text-yellow-400 pr-8 lg:pr-0">Painel Admin</h1>
          <p className="text-xs text-gray-400 mt-1 truncate pr-8 lg:pr-0">{user?.nome}</p>
        </div>

      <nav className="p-4 flex-1">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                onClick={() => {
                  if (window.innerWidth < 1024) onClose();
                }}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-yellow-500 text-gray-900 font-semibold'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

        <div className="p-4 border-t border-gray-700">
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-700 transition-colors"
          >
            <span className="text-xl">🚪</span>
            <span>Sair</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;
